"use client"

import { useCallback, useEffect, useState } from "react"

export function useHitungMundur(detikAwal: number) {
  const [sisa, setSisa] = useState(0)

  useEffect(() => {
    if (sisa <= 0) return
    const penghitung = setTimeout(() => setSisa((nilai) => nilai - 1), 1000)
    return () => clearTimeout(penghitung)
  }, [sisa])

  const mulai = useCallback(() => setSisa(detikAwal), [detikAwal])
  return { sisa, mulai }
}
